/** @format */

import * as React from "react";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import { colors, theme } from "../../Constants/theme";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { DeleteBox } from "../../Components/Layout/dialogBox/delete";
import NoData from "../Layout/AdminPanel/NoData";
import { useQueryClient } from "react-query";

// Create custom styles for DataGrid
const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-sortIcon": {
      color: theme.palette.green.dark,
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-menuIcon .MuiSvgIcon-root": {
      color: theme.palette.green.dark,
    },
    "& .MuiDataGrid-columnHeaders .css-yrdy0g-MuiDataGrid-columnHeaderRow": {
      background: `#0E8073 !important`, // Ensure the header background color is applied
      fontSize: "1rem", // Customize the header text size
      fontFamily: "roboto",
      color: colors.text.main,
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-iconButtonContainer .MuiButtonBase-root":
      {
        color: colors.text.main,
      },

    "& .MuiDataGrid-columnHeaders .MuiDataGrid-menuIcon .MuiButtonBase-root": {
      color: colors.text.main,
    },
    "& .MuiDataGrid-cell": {
      background: colors.secondary.light, // Customize the cell background color
      color: colors.text.dark, // Customize the cell text color
      fontSize: "0.875rem", // Customize the cell text size
      fontFamily: "roboto",
    },
    "& .MuiDataGrid-checkboxInput .MuiSvgIcon-root": {
      color: colors.secondary.main, // Change the checkbox color
      borderColor: "white", // Change the checkbox border color
    },
  },
});

function DataTable({ title, columns, rows, DeleteUrl, refetchUrl, addButton }) {
  const classes = useStyles();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState("");

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredRows = rows.filter((row) =>
    columns.some((column) => {
      const value = row[column.field];
      return (
        value !== undefined &&
        value !== null &&
        value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    })
  );
  const queryClient = useQueryClient();

  const handleDeleteSuccess = () => {
    setSelectedRows([]); // Clear selected rows after deletion
    queryClient.refetchQueries(refetchUrl);
  };

  // Adjust columns to use flex for equal width
  const adjustedColumns = columns.map((column) => ({
    ...column,
    flex: 1,
  }));

  console.log("selected rows", selectedRows);
  return (
    <div style={{ height: 500, width: "100%", position: "relative" }}>
      <div className='flex w-full justify-between mb-4 max-tablet:flex-col max-tablet:items-start max-desktop:mb-3 max-tablet:mb-2 items-center'>
        <div className='flex gap-4 items-center '>
          <TextField
            sx={{
              width: "250px",

              "& .MuiOutlinedInput-root": {
                background: colors.secondary.light,

                borderRadius: "10px",
                "& fieldset": {
                  borderColor: colors.primary.dark,
                },
                "&:hover fieldset": {
                  borderColor: colors.primary.main,
                },
                "&.Mui-focused fieldset": {
                  borderColor: colors.primary.light,
                  boxShadow: "2px 2px 4px #00000033",
                },
              },
              "& .MuiOutlinedInput-input": {
                padding: "8px 0px",
              },
            }}
            placeholder='...Search'
            variant='outlined'
            value={searchQuery}
            onChange={handleSearchChange}
            margin='normal'
            InputProps={{
              startAdornment: (
                <InputAdornment position='end'>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          {selectedRows.length > 0 && filteredRows.length > 0 && (
            <DeleteBox
              url={DeleteUrl}
              data={selectedRows || []}
              title={title}
              refetchUrl={refetchUrl}
              onSuccess={handleDeleteSuccess} // Call after successful delete
            >
              <h1 className='text-[1rem] font-medium text-red-600 font-roboto '>
                Delete {selectedRows.length} items!
              </h1>
              <p className='text-[1rem] font-medium font-roboto '>
                Are you sure to <span className='text-red-600'>delete</span>{" "}
                this {title}!
              </p>
            </DeleteBox>
          )}
        </div>
        <div className='max-tablet:w-full max-tablet:justify-end max-tablet:flex'>
          {addButton}
        </div>
      </div>

      {filteredRows.length === 0 ? (
        <NoData />
      ) : (
        <DataGrid
          className={classes.root}
          rows={filteredRows}
          columns={adjustedColumns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10, 20, 30]}
          checkboxSelection
          autoHeight
          onRowSelectionModelChange={handleSelectionChange}
          disableSelectionOnClick
          sx={{
            "& .MuiDataGrid-checkboxInput .MuiSvgIcon-root": {
              color: "#6ee5d6", // Change the checkbox color
              borderColor: "white", // Change the checkbox border color
            },
          }}
        />
      )}
    </div>
  );
}

DataTable.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      headerName: PropTypes.string.isRequired,
      width: PropTypes.number,
      type: PropTypes.string,
      description: PropTypes.string,
      sortable: PropTypes.bool,
      valueGetter: PropTypes.func,
    })
  ).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      lastName: PropTypes.string,
      firstName: PropTypes.string,
      age: PropTypes.number,
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DataTable;
